//Styles
import myStyles from "../../../styles/documentSigning/DocSign.requests.module.css"

//PrimeReact
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { useState } from "react"

export default function NewRequestSignerRole({
  signerRoleProfile,
  users,
  documentTemplate,
  updateDocumentTemplateCallBack,
  disabled,
}) {
  const [userType, setUserType] = useState("Participants")
  const [selectedUserID, setSelectedUserId] = useState(undefined)
  const [filteredUsers, setFilteredUsers] = useState(undefined)

  const hasParticipantAssigned = () => {
    let hasParticipant = false

    documentTemplate?.signerRoles?.forEach((s) => {
      if (s.name !== signerRoleProfile.name) {
        if (!!s.participant && !s.participant.signerId.endsWith("-STAFF")) {
          hasParticipant = true
        }
      }
    })

    return hasParticipant
  }

  const hasParticipant = hasParticipantAssigned()

  const filterUsers = (filter) => {
    let newFilteredUsers = users
    let filterValue = !!filter ? filter : userType

    switch (filterValue) {
      case "Participants":
      case "Staff":
        newFilteredUsers = newFilteredUsers.filter(
          (type) => type.name === filterValue
        )
        break
      default:
        break
    }

    if (
      !!selectedUserID &&
      !newFilteredUsers.some((group) =>
        group.items?.some((user) => user.id === selectedUserID)
      )
    ) {
      const newSelectedTemplate = { ...documentTemplate }
      newSelectedTemplate.signerRoles.forEach((s) => {
        if (s.name === signerRoleProfile.name) {
          s.participant = null
        }
      })
      setSelectedUserId(undefined)
      updateDocumentTemplateCallBack(newSelectedTemplate)
    }

    setFilteredUsers(newFilteredUsers)
  }

  if (!filteredUsers && !!users) {
    filterUsers("Participants")
  }

  return (
    <>
      <InputText
        disabled
        value={signerRoleProfile.name}
        style={{
          width: "100%",
          backgroundColor: "#efefef",
          borderColor: "#dee2e6",
        }}
      />
      <div className={myStyles.signerRoleUserGroup}>
        <Dropdown
          disabled={disabled}
          className={myStyles.signerRoleUserType}
          value={hasParticipant ? "Staff" : userType}
          options={
            hasParticipant ? ["Staff"] : ["All", "Participants", "Staff"]
          }
          onChange={(e) => {
            setUserType(e.value)
            filterUsers(e.value)
          }}
        />
        <Dropdown
          disabled={disabled}
          className={myStyles.signerRoleUsers}
          value={signerRoleProfile.participant}
          options={
            hasParticipant
              ? users.filter((type) => type.name === "Staff")
              : filteredUsers
          }
          optionLabel="name"
          onChange={(e) => {
            const newSelectedTemplate = { ...documentTemplate }
            newSelectedTemplate.signerRoles.forEach((s) => {
              if (s.name === signerRoleProfile.name) {
                s.participant = e.value
              }
            })
            setSelectedUserId(e.value)
            updateDocumentTemplateCallBack(newSelectedTemplate)
          }}
          filter
          filterBy="name"
          optionGroupLabel="name"
          optionGroupChildren="items"
        />
      </div>
    </>
  )
}
